import { useState, useEffect } from "react";

import VideoPlayer from "../../../../../components/Views/PlayerPdf";
import Loading from "../../../../../components/Shared/Loading";

function useMounted() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return mounted;
}

function Player() {
  const isMounted = useMounted();
  return <>{isMounted ? <VideoPlayer /> : <Loading />}</>;
}

export default Player;
